import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//api
import { getActivities } from 'api/company';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import NoResults from 'components/userzone/NoResults';
import CardEvent from 'components/event/cardEvent';
//styles
import './childrenBooks.scss';
//image
import Schedule from 'assets/img/ico_agenda.png';

const ActivitiesSchedule = () => {
  const [activities, setActivities] = useState([]);
  const { t } = useTranslation(['childrenBooks']);
  const { assignedLibrary } = useAssignedLibrary();

  const getActivitiesList = async () => {
    const { data, status } = await getActivities();
    if (status === 200) {
      setActivities(data?.results);
    }
  };

  useEffect(() => {
    getActivitiesList();
  }, []);

  const currentDate = new Date();
  const filteredActivities = activities.filter((activity) => {
    const activityEndDate = new Date(activity.end_date);
    return activityEndDate >= currentDate;
  });

  const sortedActivities = filteredActivities.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

  const lastFourActivities = sortedActivities.slice(-4);

  return (
    <Row>
      <Col md={12} className="d-flex subTitleCol p-0 align-items-center">
        <img src={Schedule} alt="schedule.png" />
        <h2>{t('activitiesschedule')}</h2>
      </Col>
      <Col md={12} className="d-flex mt-5 justify-content-center">
        <Row>
          {lastFourActivities.length > 0 ? (
            lastFourActivities.map((activity, index) => (
              <Col sm={12} md={6} lg={3} key={index} className="activity-item mb-4 mb-lg-0">
                <CardEvent event={activity} />
              </Col>
            ))
          ) : (
            <NoResults message={t('noActivities')} />
          )}
        </Row>
      </Col>
      {lastFourActivities.length > 0 && (
        <Link
          to={`/${assignedLibrary}/agenda?tags=Actividades%20infantiles`}
          className="text-center global-link mt-5"
        >
          {t('seemoreactivities')}
        </Link>
      )}
    </Row>
  );
};

export default ActivitiesSchedule;